import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Common_Heading_Round_holder from "../common-components/common_Heading_Round_holder/Common_Heading_Round_holder";
import Product_card from "../common-components/product_card/Product_card";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { variant_type } from "../../utils/common";
import Common_heading_holder from "../common-components/common_heading_holder/Common_heading_holder";
import No_data from "../common-components/No_data/No_data";

const STEP = 4;

function Categories() {
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);
  const [swiperInstance, setSwiperInstance] = useState(null);


  // const breadcrumbs = [
  //   { label: "Home", link: "/", isActive: false },
  //   { label: "Categories", link: "", isActive: true },
  // ];



  const [visibleCounts, setVisibleCounts] = useState([]);

  const handleToggle = (index, totalProducts, categoryId) => {
    setVisibleCounts((prevCounts) => {
      const newCounts = prevCounts.map((count, i) =>
        i === index
          ? count >= totalProducts
            ? STEP
            : Math.min(count + STEP, totalProducts)
          : count,
      );

      // Scroll if reducing to STEP
      if (prevCounts[index] >= totalProducts) {
        const el = document.getElementById(categoryId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100); // delay to ensure layout update
        }
      }

      return newCounts;
    });
  };
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const category_Id = location.state?.category_id || "";
  const [selectedCategoryId, setSelectedCategoryId] = useState(category_Id);
  useEffect(() => {
    if (category_Id) {
      setSelectedCategoryId(category_Id);
    }
  }, [category_Id]);

  const category = useSelector((state) => state.master.categories);

  const all_products = useSelector((state) => state.product.allProducts);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchValue,
        category_id: selectedCategoryId,
        // subcategory_id: subcategories?.[0]?.id,
      }),
    );
  }, [selectedCategoryId, searchValue]);

    const selectedCategory = category?.find(
  (item) => Number(item.id) === Number(selectedCategoryId)
);

const breadcrumbs = [
  { label: "Home", link: "/", isActive: false },
  {
    label: selectedCategory?.name || "Categories",
    link: "",
    isActive: true,
  },
];



  return (
    <section className="Categories_section_holder">
      <div className="container-fluid">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          {/* new code for subcategories */}

          <Common_heading_holder
            heading_text={
              <>
                <span className="black-text">Explore </span>
                <br />
                <span className="blue-text">Collection</span>
              </>
            }
          />

          <div className="cat_subcat_div">
            <div variant="pills" className="flex-row p-0 mb-3">
              <Swiper
                className="mySwiper "
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                modules={[Pagination]}
                breakpoints={{
                  0: { slidesPerView: 3, spaceBetween: 10 },
                  350: { slidesPerView: 4, spaceBetween: 10 },
                  576: { slidesPerView: 4, spaceBetween: 10 },
                  768: { slidesPerView: 5, spaceBetween: 10 },
                  992: { slidesPerView: 6, spaceBetween: 10 },
                  1200: { slidesPerView: 8, spaceBetween: 10 },
                }}
              >
                <SwiperSlide key={0} className="product-slide">
                  <Nav.Item>
                    <Nav.Link
                      eventKey=""
                      onClick={() => {
                        setSelectedCategoryId("");

                        // Clear category_Id by resetting state
                        // navigate(location.pathname, {
                        //   replace: true,
                        //   state: {},
                        // });
                      }}
                    >
                      <Category_Subcategory_Card
                        activeClassName={
                          selectedCategoryId === "" ? "activecategory" : ""
                        }
                        // activeClassName={
                        //   category_Id
                        //     ? Number(category_Id) === Number(slide?.id)
                        //       ? "activecategory"
                        //       : ""
                        //     : selectedCategoryId === slide?.id
                        //     ? "activecategory"
                        //     : ""
                        // }
                        className="product-image"
                        content="All Product"
                        image={
                          process.env.REACT_APP_IMG_URL + app_setup?.qr_image
                        }
                        imgClassName="category-image"
                      />
                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>
                {category?.map((slide, index) => (
                  <SwiperSlide key={index} className="product-slide">
                    <Nav.Item>
                      <Nav.Link
                        eventKey={slide?.id}
                        onClick={() => {
                          setSelectedCategoryId(slide?.id);

                          // Clear category_Id by resetting state
                          // navigate(location.pathname, {
                          //   replace: true,
                          //   state: {},
                          // });
                        }}
                      >
                        <Category_Subcategory_Card
                          activeClassName={
                            Number(selectedCategoryId) === Number(slide?.id)
                              ? "activecategory"
                              : ""
                          }
                          // activeClassName={
                          //   category_Id
                          //     ? Number(category_Id) === Number(slide?.id)
                          //       ? "activecategory"
                          //       : ""
                          //     : selectedCategoryId === slide?.id
                          //     ? "activecategory"
                          //     : ""
                          // }
                          className="product-image"
                          content={slide?.name}
                          image={process.env.REACT_APP_IMG_URL + slide?.image}
                          imgClassName="category-image"
                          onClick={() => {
                            dispatch(getAllProducts());
                            //  dispatch(getAllProducts(Date.now()));
                          }}
                        />

                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          {all_products?.data?.length <= 0 ? (
            <p className="text-danger">
              <No_data />
              No products available for this selection.
            </p>
          ) : (
            <>
              <Common_heading_holder
                heading_text={
                  <>
                    <span className="black-text">Discover </span>
                    <br />
                    <span className="blue-text">Products</span>
                  </>
                }
              />

              <div className="row">
                {/* {all_products?.data?.map((product, index) => { */}
                {all_products?.data?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                        productName={product?.name}
                        mrp={activeVariant?.mrp || 0}
                        priceText={activeVariant?.price || 0}
                        kgText={activeVariant?.name}
                        savingPrice={
                          parseFloat(activeVariant?.mrp || 2) -
                          parseFloat(activeVariant?.price || 2)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {/* category_wise_product */}
          {/* <div className="all_cats_div">
            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, index) => (
                <div className="Categories_holder" key={index}>
                  <div id={category.id}>
                    <h4 className="heading_text">{category.name}</h4>
                    <div className="row">
                      {category?.Products?.slice(
                        0,
                        visibleCounts[index] || STEP
                      ).map((product, idx) => (
                        <div
                          className="col-lg-4 col-md-4 col-sm-6 col-6  px-md-2 px-1 custom_5_col"
                          key={idx}
                        >
                          <Product_Info_Card
                            product={product}
                            id={product.id}
                            imgSrc={
                              process.env.REACT_APP_IMG_URL + product.image
                            }
                              vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                            productName={product.name}
                            priceText={product.Product_Variants[0]?.price}
                            mrp={product.Product_Variants[0]?.mrp}
                            kgText={product.Product_Variants[0]?.name}
                            savingPrice={
                              parseFloat(
                                product.Product_Variants[0]?.mrp || 0
                              ) -
                              parseFloat(
                                product.Product_Variants[0]?.price || 0
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {category?.Products?.length > STEP && (
                      <div className="see_more_btn_holder">
                        <Green_round_btn
                          btnText={
                            visibleCounts[index] >= category.Products.length
                              ? "See Less"
                              : "See More"
                          }
                          onClick={() =>
                            handleToggle(
                              index,
                              category.Products.length,
                              category.id
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Category Available</h3>
              </div>
            )}
          </div> */}

          {/* old code */}
          {/* <>
            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, index) => (
                <div className="Categories_holder" key={index}>
                  <div id={category.id}>
                    <Common_Heading_Round_holder headingText={category.name} />
                    <div className="row">
                      {category?.Products?.slice(
                        0,
                        visibleCounts[index] || STEP
                      ).map((product, idx) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-6  px-md-2 px-1"
                          key={idx}
                        >
                          <Product_card
                            product={product}
                            savingPrice={
                              parseFloat(product.Product_Variants[0]?.mrp) -
                              parseFloat(product.Product_Variants[0]?.price)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {category?.Products?.length > STEP && (
                      <div className="see_more_btn_holder">
                        <Green_round_btn
                          btnText={
                            visibleCounts[index] >= category.Products.length
                              ? "See Less"
                              : "See More"
                          }
                          onClick={() =>
                            handleToggle(
                              index,
                              category.Products.length,
                              category.id
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Category Available</h3>
              </div>
            )}
          </> */}
        </div>

        {/* <Stay_Connected /> */}
      </div>
    </section>
  );
}

export default Categories;
